import { render, staticRenderFns } from "./DrillAiOneQuestionMath.vue?vue&type=template&id=76cc8341&scoped=true&lang=pug&"
import script from "./DrillAiOneQuestionMath.vue?vue&type=script&lang=ts&"
export * from "./DrillAiOneQuestionMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillAiOneQuestionMath.vue?vue&type=style&index=0&id=76cc8341&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cc8341",
  null
  
)

export default component.exports